<template>
    <v-app :style="{fontFamily: fontFamily, color: contentColor}">
        <v-navigation-drawer
            v-model="drawer"
            app
            :permanent="($vuetify.breakpoint.xlAndUp) ? true : false"
            v-if="pages.length>0"
        >
            <v-list-item :style="{backgroundColor: navColor}">
                <v-list-item-content>
                    <v-list-item-title class="text-h6" :style="{color: textnavColor}">
                        {{ storeName }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            <!-- main list -->
            <v-list
                nav
            >
                <v-list-item :href="`/${slug}`">
                    <v-list-item-title>Tienda</v-list-item-title>
                </v-list-item>
                <template v-for="(page, k) in pages">
                    <v-list-item :href="`/${slug}/my/${page.slug}`" :key="k">
                        <v-list-item-title>{{ page.title }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
            <!-- end main list -->
        </v-navigation-drawer>

        <!-- app bar -->
        <v-app-bar
            app
            :color="bannerColor"
            :src="(ifBanner)?banner:''"
            :height="height"
            elevate-on-scroll
            :class="(typeHeader=='header1')?'header1':'header2'"
        >
            <template v-slot:img="{ props }">
                <v-img
                    v-bind="props"
                    :gradient="`to top right, ${bannerColor}96, ${bannerColor}59`"
                ></v-img>
            </template>

            <div class="flex-1 d-flex align-center" v-if="typeHeader=='header1'">
                <!-- mobile -->
                <v-btn
                    icon
                    :x-large="!$vuetify.breakpoint.smAndDown"
                    :color="textbannerColor"
                    class="ml-0"
                    @click.stop="drawer = !drawer"
                    v-if="pages.length>0"
                >
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    icon
                    :x-large="!$vuetify.breakpoint.smAndDown"
                    :color="textbannerColor"
                    class="ml-0"
                    @click="dialogSearch=!dialogSearch"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <!-- mobile END -->
            </div>
            <div class="flex-1" v-if="typeHeader=='header2'">
                <v-img
                    :src="logo"
                    :max-width="($vuetify.breakpoint.mdAndUp)?90:65"
                    height="auto"
                    class="rounded-lg"
                ></v-img>
            </div>

            <!-- <v-spacer></v-spacer> -->

            <v-toolbar-title class="flex-2 text-center">
                <img :src="logo" alt="Logo" v-if="typeHeader=='header1'">
                <v-card :width="($vuetify.breakpoint.mdAndUp)?500:'auto'" v-if="typeHeader=='header2' && !$vuetify.breakpoint.xsOnly" rounded="pill" class="main-search mx-auto">
                    <v-text-field
                        placeholder="¿Qué te gustaría pedir?"
                        outlined
                        rounded
                        hide-details
                        dense
                        :color="btnColor"
                        v-model="txt"
                        :loading="loadSearch"
                    >
                        <template v-slot:append>
                            <v-btn
                                icon
                                class="elevation-0 mt-0"
                                :color="btnColor"
                                @click="searchProducts"
                            >
                                <v-icon>
                                    mdi-magnify
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card>
            </v-toolbar-title>

            <!-- <v-spacer></v-spacer> -->

            <div v-if="typeHeader=='header1'" class="flex-1 d-flex align-center justify-end text-right">
                <!-- <v-btn
                    icon
                    :x-large="!$vuetify.breakpoint.smAndDown"
                    :color="textbannerColor"
                    @click="dialogSearch=!dialogSearch"
                    v-if="!$vuetify.breakpoint.smAndDown"
                >
                    <v-icon>mdi-magnify</v-icon>
                </v-btn> -->

                <template v-if="funLogin">
                    <v-menu bottom offset-y v-if="name!=''">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                :color="textbannerColor"
                                :x-large="!$vuetify.breakpoint.smAndDown"
                            >
                                <v-icon>mdi-account-circle</v-icon>
                            </v-btn>
                        </template>

                        <v-list style="min-width: 250px">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Hola!</v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="logout">
                                <v-icon>mdi-logout-variant</v-icon> &nbsp;
                                Salir
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn
                        v-else
                        icon
                        :color="textbannerColor"
                        :x-large="!$vuetify.breakpoint.smAndDown"
                        @click="dialogLogin=!dialogLogin"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <v-badge
                    :content="cantProds"
                    :value="cantProds"
                    :color="btnColor"
                    overlap
                    v-if="funCart"
                >
                    <v-btn icon :x-large="!$vuetify.breakpoint.smAndDown" :color="textbannerColor" @click="openCart=!openCart" :disabled="emergency">
                        <v-icon>mdi-cart</v-icon>
                    </v-btn>
                </v-badge>
            </div>
            <div v-if="typeHeader=='header2'" class="flex-1 d-flex align-center justify-end text-right">
                <v-btn
                    icon
                    x-large
                    :color="textbannerColor"
                    class="ml-0"
                    @click.stop="drawer = !drawer"
                    v-if="pages.length>0"
                >
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
                <template v-if="funLogin">
                    <v-menu bottom offset-y v-if="name!=''">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                :color="textbannerColor"
                                :x-large="!$vuetify.breakpoint.smAndDown"
                            >
                                <v-icon>mdi-account-circle</v-icon>
                            </v-btn>
                        </template>

                        <v-list style="min-width: 250px">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Hola!</v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="logout">
                                <v-icon>mdi-logout-variant</v-icon> &nbsp;
                                Salir
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn
                        v-else
                        icon
                        :color="textbannerColor"
                        :x-large="!$vuetify.breakpoint.smAndDown"
                        @click="dialogLogin=!dialogLogin"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <v-badge
                    :content="cantProds"
                    :value="cantProds"
                    :color="btnColor"
                    overlap
                    v-if="funCart"
                >
                    <v-btn icon :x-large="!$vuetify.breakpoint.smAndDown" :color="textbannerColor" @click="openCart=!openCart" :disabled="emergency">
                        <v-icon>mdi-cart</v-icon>
                    </v-btn>
                </v-badge>
            </div>


            <template v-slot:extension>
                <v-card width="100%" class="px-5 pt-1 pb-2" tile elevation="0" v-if="typeHeader=='header2' && $vuetify.breakpoint.xsOnly">
                    <v-card-text class="pa-0 d-flex align-center">
                        <v-text-field
                            placeholder="¿Qué te gustaría pedir?"
                            outlined
                            dense
                            hide-details
                            autofocus
                            :color="btnColor"
                            v-model="txt"
                            :loading="loadSearch"
                        >
                            <template v-slot:append>
                                <v-btn
                                    icon
                                    small
                                    color="red"
                                    class="mt-n1"
                                    @click="clearSearch"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                        <v-btn
                            :color="btnColor"
                            :style="`color:${textbtnColor}`"
                            class="ml-1"
                            @click="searchProducts"
                        >Buscar</v-btn>
                    </v-card-text>
                </v-card>
                <v-tabs
                    slider-size="0"
                    :background-color="navColor"
                    :color="btnColor"
                    centered
                    show-arrows
                    v-model="tmpTab"
                >
                    <template v-for="(cat, k) in dataCats">
                        <div>
                            <v-tab @click="redirectHref(`/${slug}/#${cat.slug}`)" v-if="cat.products_count > 0 && cat.children.length==0" class="h-full">
                                <div :style="`color:${textnavColor}`">{{ cat.name }}</div>
                                <span class="line" :style="`background-color:${textnavColor}`"></span>
                            </v-tab>
                            <!-- subcategorias -->
                            <v-menu
                                open-on-hover
                                offset-y
                                v-if="cat.children.length>0"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-tab
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="redirectHref(`/${slug}/#${cat.slug}`)"
                                        class="h-full"
                                        active-class="active"
                                        v-if="cat.products_count"
                                    >
                                        <div :style="`color:${textnavColor}`">{{ cat.name }}</div>
                                        <span class="line" :style="`background-color:${textnavColor}`"></span>
                                        <v-icon right>
                                        mdi-menu-down
                                        </v-icon>
                                    </v-tab>
                                    <v-tab
                                        v-bind="attrs"
                                        v-on="on"
                                        class="h-full"
                                        active-class="active"
                                        v-else
                                    >
                                        <div :style="`color:${textnavColor}`">{{ cat.name }}</div>
                                        <span class="line" :style="`background-color:${textnavColor}`"></span>
                                        <v-icon right>
                                        mdi-menu-down
                                        </v-icon>
                                    </v-tab>
                                </template>
    
                                <v-list>
                                    <v-list-item
                                        v-for="sub in cat.children"
                                        :key="sub.id"
                                        v-if="sub.products_count > 0"
                                        @click="redirectHref(`/${slug}/#${sub.slug}`)"
                                    >
                                        {{ sub.name }}
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                </v-tabs>
            </template>
        </v-app-bar>
        <!-- end app bar -->

        <!-- app main -->
        <v-main class="bg" :class="(typeHeader=='header1')?'main-header1':'main-header2'" :style="(ifBody)?`background-image: url(${body})`:`background-color: ${bodyColor}`">
            <single-product
                :slug="slug"
                :product-id="productId"
                :title-color="titleColor"
                :title-card-color="titleCardColor"
                :price-color="priceColor"
                :btn-color="btnColor"
                :textbtn-color="textbtnColor"
                :banner-color="bannerColor"
                :textnav-color="textnavColor"
                :nav-color="navColor"
                :font-family="tmpFontFamily"
                :data-my-store="dataMyStore"
                :consult-wps="consultWps"
                :store-phone="storePhone"
                :code-phone="codePhone"
                :store-name="storeName"
                :emergency="emergency"
                :money="money"
                :if-load-more="ifLoadMore"
                :content-color="contentColor"
                :temp-mode="tempMode"
                :search-prod="txt"
                :loading2="loading2"
                :to="to"
                :total="totalPag"
                :mobile-columns="mobColumns"
                :desktop-columns="deskColumns"
                :fun-cart="funCart"
                :location-map="locationMap"
                :type-store="typeStore"
                :inventory="inventory"
                :open-product-new-tab="openProductNewTab"
                @update-cart="updateCartFromStore"
                @open-cart="openCartFromStore"
            ></single-product>
            <!-- <slot/> -->
        </v-main>
        <!-- end app main -->

        <!-- app footer -->
        <v-footer
            padless
        >
            <v-card
                flat
                tile
                width="100%"
                class="text-center"
                :color="bannerColor"
            >
                <v-card-text>
                    <v-btn
                        text
                        :color="textbannerColor"
                        class="text-capitalize"
                        target="_blank"
                        href="https://wa.me/59169007104?text=Estoy%20interesado%20en%20QUICK%0AQuiero%20empezar%20a%20vender%20en%20l%C3%ADnea%20hoy"
                    >
                        <strong>QUICK</strong> © {{ new Date().getFullYear() }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-footer>
        <!-- end app footer -->

        <!-- Redes sociales -->
        <div class="wrap-rrss">
            <div v-for="(rrss, i) in dataRrss" :key="i" class="ma-1">
                <v-tooltip top class="d-block">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            dark
                            small
                            v-bind="attrs"
                            v-on="on"
                            :href="rrss.url"
                            target="_blank"
                        >
                            <v-icon>{{ rrss.icon }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ rrss.name }}</span>
                </v-tooltip>
            </div>
        </div>
        <!-- end Redes sociales -->

        <!-- bottom -->
        <template v-if="funCart">
            <v-card
                v-if="cantProds>0 || showListCoupons"
                class="ed-sheet"
                tile
            >
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="8" offset-sm="2" v-if="showListCoupons" :class="(cantProds>0)?'pb-1':''">
                            <v-row no-gutters align="center">
                                <v-col cols="6" sm="5" class="text-center text-sm-right">
                                    <div :style="`color:${titleColor}`">
                                        <Countdown class="pl-0" v-if="showTime" :end="currentTime"></Countdown>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="7">
                                    <div
                                        v-for="item in listCoupons"
                                        :key="item.name"
                                        class="d-flex justify-center align-center"
                                    >
                                        <!-- <span class="pr-2">{{ item.name }}</span> -->
                                        <v-btn
                                            small
                                            class="pl-2"
                                            :color="btnColor"
                                            :style="`color:${textbtnColor}`"
                                            @click="copyData(item.name), minimumTxt=item.minimum"
                                        >Copiar cupón</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" v-if="cantProds>0" class="pb-btn" :class="(showListCoupons)?'pt-1':''">
                            <v-btn
                                block
                                large
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="openCart=!openCart"
                            >
                                <strong>Ir al pago</strong>
                                <v-icon right>mdi-cart</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </template>
        <!-- end bottom -->

        <!-- dialog cart -->
        <v-dialog
            v-model="openCart"
            transition="dialog-bottom-transition"
            scrollable
            fullscreen
            content-class="dialog-full"
        >
            <v-card tile v-if="JSON.stringify(cart) != '{}'">
                <v-card-title class="container arrow-right">
                    <h3 class="mt-3 mb-5 text-h5 text-md-h4">Resumen del pedido</h3>
                </v-card-title>
                <v-card-text class="container">
                    <template>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Cantidad
                                    </th>
                                    <th class="text-left">
                                        Producto
                                    </th>
                                    <th class="text-right">
                                        Precio
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in cart" :key="i">
                                    <td class="text-left">{{ item.quantity }}x</td>
                                    <td class="text-left">
                                        {{ item.name }} <br>
                                        <small class="grey--text text-lighten-1">{{ item.complementsDetails }}</small>
                                    </td>
                                    <td class="text-right">{{ ((item.priceNormal>0)?item.priceNormal:item.price).toFixed(2) }}</td>
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="openDetails(item, i)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="removeItemOfCart(item.prodId, i)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="blue-grey lighten-5">
                                    <td colspan="2">
                                        <strong class="text-h6 text-md-h6">Subtotal {{ money }}</strong>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <strong class="text-h6 text-md-h6">{{ (total).toFixed(2) }}</strong>
                                    </td>
                                </tr>
                                <tr class="blue-grey lighten-5">
                                    <td colspan="2">
                                        <strong class="text-h6 text-md-h6">Descuento {{ money }}</strong>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <strong class="text-h6 text-md-h6">{{ (valCoupon + discountProds).toFixed(2) }}</strong>
                                    </td>
                                </tr>
                                <tr class="blue-grey lighten-5">
                                    <td colspan="2">
                                        <strong class="text-h6 text-md-h5">Total {{ money }}</strong>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <strong class="text-h6 text-md-h5">{{ ( ((total- (valCoupon + discountProds) )>0)?(total- (valCoupon + discountProds) ):0 ).toFixed(2) }}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                            </template>
                        </v-simple-table>
                    </template>
                    <v-row no-gutters align="center" class="mt-10">
                        <v-col cols="12" v-if="minimumTxt!='-'">
                            Cupón válido para una compra mínima de {{ money }} {{ minimumTxt }}
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <v-text-field
                                label="Ingresar cupón"
                                outlined
                                dense
                                hide-details
                                :color="btnColor"
                                v-model="couponTxt"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <v-btn
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="applyCoupon"
                                :disabled="couponTxt==''"
                            >Aplicar cupón</v-btn>
                        </v-col>
                    </v-row>
                    <!-- {{ cart }} -->
                    <v-row class="mt-8 mb-5">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn
                                block
                                large
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="openPurchase"
                            ><strong>Continuar</strong></v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a=============%0a%20${wspCart}=============%0ami%20consulta%20es%20...`"
                                target="_blank"
                            >
                                <v-icon left>
                                    mdi-whatsapp
                                </v-icon>
                                <strong>Consultar por WhatsApp</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card tile v-else>
                <v-card-title class="container arrow-center arrow-right">
                    <h3 class="mt-3 mb-5">Tu carrito esta vacío</h3>
                </v-card-title>
                <v-card-text>
                    <!-- {{ cart }} -->
                    <v-row class="mt-8 mb-5">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn
                                block
                                large
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="openCart = !openCart"
                            >Volver a la tienda</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialog cart end -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title :style="`color:${navColor}`" class="pa-0">
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            v-if="bannerProd != 'none'"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="(img, j) in galleryProd" :key="j"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%" :style="{'color':contentColor}">
                            {{ nameProd }}
                        </div>
                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd" v-html="descriptionProd"></div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3" :style="{backgroundColor: navColor, color: textnavColor}">
                            {{ row.title }}
                        </v-card-title>
                        <v-alert
                            :key="j+1*150"
                            dense
                            tile
                            outlined
                            type="error"
                            v-if="showAlertRequired && row.isRequired"
                        >Debe seleccionar una opción para continuar</v-alert>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <template dense>
                                <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} +{{ opt.price }}</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-btn
                                            small
                                            :disabled="opt.quantity<=0"
                                            @click="changeQtyMultiple(row, opt, -1)"
                                        >
                                            <v-icon dark>
                                                mdi-minus
                                            </v-icon>
                                        </v-btn>
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                        <v-btn
                                            small
                                            :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                            @click="changeQtyMultiple(row, opt, 1)"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${(row.quantities)?(opt.quantity*quantity):opt.quantity}`"></span>

                                    <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                    <v-list-item-action v-if="!row.ifQuantity">
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            :color="btnColor"
                                            :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                            @change="changeRespMultiple"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                            <!-- <v-list-item-group
                                v-model="row.tmpVal"
                                multiple
                                active-class=""
                                @change="changeRespMultiple"
                            >
                                <v-list-item :disabled=" ((row.tmpVal).includes(opt.name+':'+opt.price)) ? false : ((row.tmpVal).length >= row.select) " v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">+{{ opt.price }} {{ money }}</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-checkbox-marked
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group> -->
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                                @change="beforeChangeRespOnly(row, $event)"
                            >
                                <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+((row.quantities)?(opt.price*quantity):opt.price)">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} +{{ opt.price }}</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <div class="px-5 pt-5">
                        <v-textarea
                            outlined
                            placeholder="Dato extra"
                            :color="btnColor"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div>

                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="updateToCart"
                                :disabled="disabledBtn"
                            >
                                <strong>Actualizar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- dialog purchase -->
        <v-dialog
            v-model="dialogPurchase"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <app-purchase
                :slug="slug"
                :title-color="titleColor"
                :btn-color="btnColor"
                :textbtn-color="textbtnColor"
                :banner-color="bannerColor"
                :textnav-color="textnavColor"
                :nav-color="navColor"
                :data-my-store="dataMyStore"
                :up-cart="cart"
                :font-family="tmpFontFamily"
                :last-purchase="lastPurchase"
                :closed-store="closedStore"
                :money="money"
                :content-color="contentColor"
                :temp-mode="tempMode"
                :iso2="iso2"
                :valCoupon="valCoupon"
                :discountProds="discountProds"
                :nameCoupon="nameCoupon"
                :fun-login="funLogin"
                :fidely-points="fidelyPoints"
                :fidely-points-value="fidelyPointsValue"
                :fidely-points-url="fidelyPointsUrl"
                :is-domain="isDomain"
                @send-success="successOrder"
                @close-purchase="dialogPurchase=!dialogPurchase"
            ></app-purchase>
                <!-- @update-cart="updateCartFromStore" -->
        </v-dialog>
        <!-- dialog purchase END -->

        <v-dialog
            v-model="dialogSearch"
            fullscreen
            transition="dialog-bottom-transition"
            content-class="dialog-fullwidth white"
        >
            <v-container>
                <v-card tile elevation="0">
                    <v-card-text class="pa-0 d-flex align-center">
                        <!-- prepend-inner-icon="mdi-magnify" -->
                        <!-- @input="searchProducts" -->
                        <v-text-field
                            placeholder="¿Qué te gustaría pedir?"
                            outlined
                            dense
                            hide-details
                            autofocus
                            :color="btnColor"
                            v-model="txt"
                            :loading="loadSearch"
                        >
                            <template v-slot:append>
                                <v-btn
                                    icon
                                    small
                                    color="red"
                                    class="mt-n1"
                                    @click="clearSearch"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                        <v-btn
                            :color="btnColor"
                            :style="`color:${textbtnColor}`"
                            class="ml-1"
                            @click="searchProducts"
                        >Buscar</v-btn>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-dialog>

        <!-- alert -->
        <v-dialog
            v-model="closedStoreDialog"
            width="500"
        >
            <v-card :style="{fontFamily: fontFamily, color: contentColor}">
                <v-card-title class="grey lighten-2">
                    {{ closingData.title?closingData.title:'Aviso!' }}
                </v-card-title>

                <v-card-text class="pt-3">
                    {{ closingData.content?closingData.content:'En este instante está fuera de los horarios de atención, pero no se preocupe, puede programar su orden para otra hora o fecha.' }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        @click="closedStoreDialog = false"
                    >
                        Entendido
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- alert END -->

        <!-- alert -->
        <v-dialog
            v-model="emergencyDialog"
            width="300"
            overlay-opacity=".9"
        >
            <v-card :style="{fontFamily: fontFamily, color: contentColor}">
                <v-card-title class="grey lighten-2">
                    Volvemos pronto!
                </v-card-title>

                <v-card-text class="pt-3">
                    La tienda se encuentra cerrado por una emergencia, volvemos pronto.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        @click="emergencyDialog = false"
                    >
                        Entendido
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- alert END -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogLogin"
            max-width="400"
            content-class="grey lighten-4"
        >
            <v-card>
                <v-card-title>
                    <strong>Inicia sesión</strong>
                </v-card-title>
            </v-card>
            <v-card-text>
                <p class="grey--text"><small>Si ya tienes una cuenta puedes iniciar sesión desde aquí.</small></p>
                <v-form @submit.prevent="loginUser" ref="refLogin" lazy-validation>
                    <v-text-field
                        label="Número de celular"
                        outlined
                        dense
                        :color="btnColor"
                        type="text"
                        v-model="dataAuth.username"
                        :rules="[rules.required]"
                        :error="errors['username'] ? true :false"
                        :error-messages="errors['username'] ? errors['username'][0] : ''"
                    >
                        <!-- <template v-slot:prepend-inner>
                            <div class="ed-prepend">
                                +591
                            </div>
                        </template> -->
                    </v-text-field>
                    <v-text-field
                        label="Contraseña"
                        outlined
                        dense
                        :color="btnColor"
                        type="password"
                        v-model="dataAuth.password"
                        :rules="[rules.required]"
                        :error="errors.password ?true :false"
                        :error-messages="errors['password'] ? errors['password'][0] : ''"
                    ></v-text-field>
                    <!-- <div class="text-left mb-4">
                        <a href="javascript:;" @click="dialogLogin=false, dialogReset=true">Recuperar contraseña</a>
                    </div> -->
                    <v-btn
                        :color="btnColor"
                        :style="`color:${textbtnColor}`"
                        block
                        type="submit"
                        :loading="loading"
                    ><strong>Ingresar</strong></v-btn>
                </v-form>
            </v-card-text>
        </v-dialog>
        <!-- end dialog -->

        <!-- notify -->
        <v-dialog
            v-model="dialogNotify"
            width="500"
            overlay-opacity=".9"
        >
            <v-card :style="{fontFamily: fontFamily, color: contentColor}">
                <v-btn
                    fab
                    small
                    absolute
                    right
                    style="z-index:1;top:10px;"
                    @click="dialogNotify = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-img
                    :src="bannerNotify"
                    :aspect-ratio="sizeNotify"
                ></v-img>
                <v-card-actions v-if="listCoupons.length > 0">
                    <div style="width:100%">
                        <v-row align="center">
                            <v-col cols="7" class="text-right" :style="`color:${titleColor}`">
                                <h4>Válido por</h4>
                                <Countdown class="pl-0" v-if="showTime" :end="currentTime"></Countdown>
                            </v-col>
                            <v-col cols="5">
                                <v-btn
                                    :color="btnColor"
                                    :style="`color:${textbtnColor}`"
                                    large
                                    @click="useCoupon()"
                                >Usar</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- notify END -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="success"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-app>
</template>
<script>
import Countdown from 'vuejs-countdown'
export default {
    components: { Countdown },
    data() {
        return {
            tmpName: '',
            overlay: true,
            drawer: false,
            // menu
            dataMyStore: [],
            storePhone: '',
            storeName: '',
            // settings
            bannerColor: '',
            textbannerColor: '',
            navColor: '',
            textnavColor: '',
            ifBanner: true,
            logo: '',
            banner: '',
            btnColor: '',
            textbtnColor: '',
            contentColor: '',
            titleColor: '',
            titleCardColor: '',
            priceColor: '',
            fontFamily: '',
            tmpFontFamily: '',
            consultWps: false,
            ifBody: false,
            bodyColor: '',
            body: '',
            emergency: false,
            emergencyDialog: false,
            money: '',
            ifLoadMore: true,
            mobColumns: 6,
            deskColumns: 3,
            typeHeader: '',
            funCart: false,
            funLogin: false,
            fidelyPoints: false,
            fidelyPointsValue: 0,
            fidelyPointsUrl: '',
            isDomain: '',
            // cart
            openCart: false,
            cart: {},
            tmpIndex: null,
            wspCart: '',
            cantProds: 0,
            total: 0,
            // open product
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            priceNormal: null,
            stock: 100,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: '',
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            // purchase
            dialogPurchase: false,
            iso2: '',
            codePhone: '',
            // search
            dialogSearch: false,
            loadSearch: false,
            txt: '',
            // last
            lastPurchase: {},
            // schedukes
            listSchedules: {},
            closedStore: false,
            closedStoreDialog: false,
            closingData: {},
            // login
            loading: false,
            dialogLogin: false,
            dataAuth: {
                username: '',
                password: ''
            },
            // notify
            dialogNotify: false,
            bannerNotify: '',
            sizeNotify: 0,
            // mode
            tempMode: 'order_auto',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos'
            },
            errors: {},
            // pages
            pages: [],
            // time
            currentTime: null,
            showTime: false,
            listCoupons: [],
            couponTxt: '',
            couponTxt2: '',
            minimumTxt: '',
            nameCoupon: '',
            valCoupon: 0,
            tmpValCoupon: 0,
            typeCoupon: 'fixed',
            showListCoupons: false,
            discountProds: 0,
            // paginate
            page: 1,
            totalPag: null,
            to: null,
            loading2: false,
            // cats
            dataCats: [],
            getPag: '',
            // banners
            dataBanners: [],
            currentURL: window.location.href,
            // rrss
            dataRrss: [],
            typeStore: '',
            // location
            locationMap: '',
            extraComplement: [],
            tmpCombination: {},
            disabledBtn: false,
            tmpPriceCombination: null,
            tmpTab: 0,
            // 
            openProductNewTab: false
        }
    },
    props: ['slug', 'msgNotify', 'name', 'userId', 'inventory', 'productId'],
    mounted() {
        this.getSettingStore()
        this.getDataStore()

        if (localStorage.getItem(this.slug)) {
            this.cart = JSON.parse(localStorage.getItem(this.slug))

            for (var [key, value] of Object.entries(this.cart)) {
                var tmpComplements = this.cart[key].complements
                this.cart[key].complementsDetails = ''
                if (tmpComplements.multi.length > 0) {
                    tmpComplements.multi.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
                if (tmpComplements.only.length > 0) {
                    tmpComplements.only.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
            }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
            this.generateMsgWsp()
        }

        // login
        if (localStorage.getItem('login')) {
            setTimeout(() => {
                this.$fire({
                    title: 'Inicio de sesión con éxito.',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Continuar',
                    confirmButtonColor: this.btnColor,
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.tmpFontFamily
                    }
                })
                localStorage.removeItem('login')
            }, 300);
        }

        // timer
        if (sessionStorage.getItem(`${this.slug}-coupon`)) {
            this.showListCoupons = sessionStorage.getItem(`${this.slug}-coupon`)
        }

        // notify
        this.showAds();

        // timer
        // this.showTimeDiv()
        this.showCoupons()

        // banners
        this.getMainBanner();

        // rrss
        this.getMainRrss();
    },
    created() {
        if (this.msgNotify) {
            switch (this.msgNotify) {
                case 'success':
                    this.dialogOkProd = true
                    break;
                case 'error':
                    this.dialogErrorProd = true
                    break;
                default:
                    this.$notify.info(this.msgNotify)
                    break;
            }
        }
    },
    watch: {
        dialogNotify(e) {
            if (!e) {
                sessionStorage.setItem(`${this.slug}-notify`, 0)
            }
        },
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = ''
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        },
        openCart(e) {
            if (e) {
                // console.log('open cart');
                this.couponTxt = localStorage.getItem(`${this.slug}-coupon`)??''
            }
        },
        total(e) {
            if (e) {
                if (this.typeCoupon == 'percentage') {
                    this.valCoupon = ((+this.total)*((+this.tmpValCoupon)/100))
                }
            }
        }
    },
    methods: {
        redirectHref(url) {
            window.location.href = url
        },
        // Copy Text to Clipboard
        async copyData(txt) {
            var temp = document.querySelector('.temp-copy');
            temp.value = txt;
            temp.select();
            document.execCommand('copy');
            this.$notify.success('Cupón copiado.')
        },
        /**
         * login
         */
        async loginUser() {
            if (this.$refs.refLogin.validate()) {
            // if (true) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('login', this.dataAuth.username)
                formData.append('password', this.dataAuth.password)
                formData.append('store', this.slug)
                await axios.post('/login', formData)
                .then(response => {
                    // console.log(response)
                    if (response.status === 204) {
                        window.location.reload()
                        localStorage.setItem('login', 'ok')
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        /**
         * logout
         */
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * active tab
         */
        updateTabs() {
            switch (window.location.pathname) {
                case '/':
                    this.tab = 0;
                    break;
                case '/categorias':
                    this.tab = 1;
                    break;
                case '/productos':
                    this.tab = 2;
                    break;
                default:
                    this.tab = null;
                    break;
            }
        },
        goTo(to) {
            window.location.href = to
        },
        /**
         * logout
         */
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    localStorage.removeItem('name')
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },

        /**
         * main store
         */
        async getSettingStore() {
            const formData = new FormData
            // formData.append('slug', this.slug)
            // formData.append('_method', 'POST')
            await axios.get(`/store-data/${this.slug}`)
            .then(response => {
                // console.log(response)
                if (response.data[0]) {
                    this.bannerColor = response.data[0].banner_color
                    this.textbannerColor = response.data[0].textbanner_color
                    this.navColor = response.data[0].nav_color
                    this.textnavColor = response.data[0].textnav_color
                    this.ifBanner = response.data[0].if_banner
                    this.logo = response.data[0].logo
                    this.banner = response.data[0].banner
                    this.btnColor = response.data[0].btn_color
                    this.textbtnColor = response.data[0].textbtn_color
                    this.contentColor = response.data[0].content_color
                    this.titleColor = response.data[0].title_color
                    this.titleCardColor = response.data[0].titlecard_color
                    this.priceColor = response.data[0].price_color
                    this.fontFamily = response.data[0].font_family
                    this.consultWps = (response.data[0].consult_wps)?true:false
                    this.ifBody = response.data[0].if_body
                    this.bodyColor = response.data[0].body_color
                    this.body = response.data[0].body
                    this.emergency = (response.data[0].emergency)?true:false
                    this.emergencyDialog = (response.data[0].emergency)?true:false
                    const font = (response.data[0].font_family).replace(/[^a-zA-Z ]/g, "")
                    this.tmpFontFamily = font.replace(/\s+/g, '-').toLowerCase()
                    this.money = response.data[0].money
                    this.ifLoadMore = (+response.data[0].if_load_more)?true:false
                    this.mobColumns = (response.data[0].mob_columns == 1) ? 12 : 6
                    this.typeHeader = response.data[0].type_header
                    this.funCart = (response.data[0].fun_cart)?true:false
                    this.funLogin = (response.data[0].fun_login)?true:false

                    if (response.data[10].fidely_points) {
                        this.fidelyPoints = response.data[10].fidely_points,
                        this.fidelyPointsValue = response.data[10].fidely_points_value
                        this.fidelyPointsUrl = response.data[10].fidely_points_url
                    }

                    this.isDomain = response.data[11] ? true:false

                    switch (response.data[0].desk_columns) {
                        case 6:
                            this.deskColumns = 2
                            break;
                        case 5:
                            this.deskColumns = 2.4
                            break;
                        case 4:
                            this.deskColumns = 3
                            break;
                        default:
                            this.deskColumns = 4
                            break;
                    }

                    // store actions
                    this.$store.dispatch('numberDecimals/setNumberDecimals', response.data[0].number_decimals)
                }
                if (response.data[1]) {
                    this.listSchedules = response.data[1]
                    this.getAttentions(this.listSchedules, true)
                }
                if (response.data[2]) {
                    this.storePhone = response.data[2]
                }
                if (response.data[3]) {
                    this.storeName = response.data[3]
                }
                if (response.data[4]) {
                    this.pages = response.data[4]
                }
                if (response.data[5]) {
                    this.tempMode = response.data[5]
                }
                if (response.data[6]) {
                    this.iso2 = response.data[6]
                }
                if (response.data[7]) {
                    this.codePhone = response.data[7]
                }
                if (response.data[8]) {
                    this.closingData = response.data[8]
                }
                if (response.data[9]) {
                    this.locationMap = response.data[9]
                }
                if (response.data[12]) {
                    this.typeStore = response.data[12]
                }
                if (response.data[13]) {
                    this.openProductNewTab = response.data[13] ? true : false
                }
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        loadMoreCats() {
            this.page += 1
            this.loading2 = true
            this.getDataStore()
        },
        clearSearch() {
            this.getPag = ''
            this.dataMyStore = []
            this.txt = ''
            this.getDataStore()
            this.dialogSearch = false
        },
        searchProducts() {
            this.getPag = 'all'
            this.dataMyStore = []
            if (this.txt!='') this.loadSearch = true
            setTimeout(() => {
                this.getDataStore(this.txt)
            }, 500);
        },
        async getDataStore(txt='') {
            await axios.post('/my-store', {page: this.page, slug: this.slug, search: txt, getpag: this.getPag})
            .then((response) => {
                // console.log(response);
                // this.dataMyStore = response.data.data
                response.data[0].data.forEach(element => {
                    this.dataMyStore.push(element)
                    element.products.forEach(prod => {
                        prod.promo = false
                        const tempDates = JSON.parse(prod.promo_dates)
                        const tempInit = prod.promo_init
                        const tempEnd = prod.promo_end
                        if (tempDates && tempDates.length>0) {
                            // dates
                            const d = new Date()
                            const init = new Date()
                            const end = new Date()
                            const currentDate = d.getFullYear() +'-'+ ( (d.getMonth()<9)?'0'+(d.getMonth()+1):(d.getMonth()+1) ) +'-'+ ( (d.getDate()<10)?'0'+d.getDate():d.getDate() )
                            if (tempDates.includes(currentDate)) {
                                if (tempInit && tempEnd) {
                                    const on = tempInit.split(':')
                                    init.setHours(+on[0])
                                    init.setMinutes(+on[1])
                                    // init.setSeconds(+on[2])
                                    const off = tempEnd.split(':')
                                    end.setHours(+off[0])
                                    end.setMinutes(+off[1])
                                    // end.setSeconds(+off[2])

                                    if (d.getTime() > init.getTime() && d.getTime() < end.getTime()) {
                                        prod.promo = true
                                    }
                                }
                            }
                        }
                    });
                });
                this.to = response.data[0].to
                this.totalPag = response.data[0].total

                this.dataCats = response.data[1]

                this.loadSearch = false
                this.dialogSearch = false
                this.loading2 = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loadSearch = false
                this.loading2 = false
            })
        },

        /**
         * update cart
         */
        updateCartFromStore(cart) {
            this.cart = JSON.parse(cart)

            for (var [key, value] of Object.entries(this.cart)) {
                var tmpComplements = this.cart[key].complements
                this.cart[key].complementsDetails = ''
                if (tmpComplements.multi.length > 0) {
                    tmpComplements.multi.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
                if (tmpComplements.only.length > 0) {
                    tmpComplements.only.forEach(element => {
                        this.cart[key].complementsDetails += element.split(':')[0]
                        this.cart[key].complementsDetails += ', '
                    });
                }
            }

            this.cantProds = Object.keys(this.cart).length;
            this.calculateTotal()
            this.generateMsgWsp()
        },
        /**
         * open cart
         */
        openCartFromStore(open) {
            if (open) {
                this.openCart = true
            }
        },
        /**
         * calculate total
         */
        calculateTotal() {
            this.total = 0;
            this.discountProds = 0;
            Object.keys(this.cart).forEach(key => {
                this.total += ((this.cart[key].priceNormal>0)?this.cart[key].priceNormal:this.cart[key].price);
                this.discountProds += ((this.cart[key].priceNormal>0) ? (this.cart[key].priceNormal-this.cart[key].price) :0);
            });
        },
        /**
         * remove item
         */
        removeItemOfCart(prod, i) {
            this.$confirm(
                '¿Está seguro de eliminar este elemento?',
                'Confirmar',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Sí',
                confirmButtonColor: this.btnColor,
                cancelButtonText: 'No',
                customClass: {
                    container: this.tmpFontFamily
                }
            }).then(res => {
                if (res) {
                    if (localStorage.getItem(this.slug)) {
                        const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                        const newCart = {}
                        for (var [key, value] of Object.entries(tmpCart)) {
                            // if (prod.toString() !== key) {
                            if (i.toString() !== key) {
                                newCart[key] = value
                            }
                        }
                        localStorage.setItem(this.slug, JSON.stringify(newCart))

                        this.updateCartFromStore(JSON.stringify(newCart))
                        this.$notify.success('Se retiro el producto del carrito.');
                    }
                }
            });
        },
        /**
         * open
         */
         getComplementsTitles() {
             // nombre de la opción -> título del complemento, para los mensajes de WhatsApp
             const titles = { multi: {}, only: {} }
             this.optionsProd.forEach(row => {
                 const group = (row.type == 'multiple') ? titles.multi : titles.only
                 row.values.forEach(opt => {
                    // nombre:precio distingue opciones homónimas entre complementos; el nombre queda como respaldo
                    group[`${opt.name}:${opt.price}`] = row.title
                    group[opt.name] = row.title
                })
             })
             return titles
         },
         changeQtyMultiple(row, opt, step) {
             const key = `${opt.name.replace(' ', '-')}_${opt.price}`
             const newQty = Math.max(0, opt.quantity + step)
             // respetar la cantidad máxima de todos los complementos juntos
             if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
             const isSelected = row.tmpVal.includes(key)

             if (newQty > 0 && !isSelected) {
                 // respetar el máximo de opciones permitidas
                 if (row.tmpVal.length >= row.select) return
                 row.tmpVal.push(key)
             }
             if (newQty == 0 && isSelected) {
                 row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
             }

             opt.quantity = newQty
             this.changeRespMultiple()
         },
         changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 200);
        },
        /**
         * before
         */
         beforeChangeRespOnly(row, e) {
            if (this.typeStore == 'product') {
                const idsComplements = [...new Set(this.extraComplements.map(el => el.ids).flat())]
                if (idsComplements.includes(row.id)) {
                    // obtener el valor seleccionado
                    this.tmpCombination[row.id] = e.split(':')[0]
                    // convertir el objeto en un array
                    const arrayComplements = Object.values(this.tmpCombination)
                    // ordenar el array
                    const arrayOrderComplements = [...arrayComplements].sort((a, b) => a.length - b.length)

                    // encontrar el complemento extra
                    const fiindExtraComplement = this.extraComplements.find(item => 
                        JSON.stringify(item.names.sort((a, b) => a.length - b.length)) === JSON.stringify(arrayOrderComplements)
                    )

                    if (fiindExtraComplement) {
                        // asignar el complemento extra
                        if (fiindExtraComplement.barcode=='') {
                            this.disabledBtn = true
                            this.$notify.error('Stock agotado, no se puede agregar la combinación.')
                            this.price = this.tmpPriceCombination
                        } else {
                            this.disabledBtn = false
                            if (fiindExtraComplement.price != '') {
                                this.price = +fiindExtraComplement.price
                            } else {
                                this.price = this.tmpPriceCombination
                            }
                        }
                    }
                }
            }
            this.changeRespOnly()
        },

        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            this.showRequired = false
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(prod, index) {
            this.tmpIndex = index
            this.loadProd = true
            this.dialogProd = true
            this.tmpCombination = {}
            this.disabledBtn = false
            axios.get(`/show-product/${prod.prodId}?store=${this.slug}`)
            .then((response) => {
                // console.log(response);
                this.optionsProd = []
                this.respMultipleVal = 0

                this.respOnlyVal = 0

                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpValues = JSON.parse(element.values)
                        var tmpValues2 = []
                        var tmpValues3 = []
                        var tmp2Val = []
                        var tmp2ValOnly = undefined
                        if (element.type == 'multiple') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name.replace(' ', '-')+'_'+el.price
                                    if (prod.complements.multi.length>0) {
                                        prod.complements.multi.forEach(multi => {
                                            // console.log(multi);
                                            const selectedVal = multi.split(':')
                                            const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (selectId == txtVal) {
                                                this.respMultipleVal += (+el.price)*(+selectedVal[2])
                                                tmp2Val.push(txtVal)
                                            }
                                            if (tmpValues2[el.name.replace(' ', '-')+'_'+el.price] === undefined) tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = (element.quantity ? 0 : 1)
                                            tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        if (tmpValues2[el.name.replace(' ', '-')+'_'+el.price] === undefined) tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = (element.quantity ? 0 : 1)
                                    }
                                });
                            }

                            tmpValues.forEach(val => {
                                for (const key in tmpValues2) {
                                    if (key == val.name.replace(' ', '-')+'_'+val.price) {
                                        tmpValues3.push({name:val.name, price:val.price, quantity:tmpValues2[key]})
                                    }
                                }
                            });
                        }
                        if (element.type == 'only') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name+':'+((element.quantities)?(el.price*prod.quantity):el.price)
                                    // console.log(prod);
                                    if (prod.complements.only.length>0) {
                                        prod.complements.only.forEach(only => {
                                            // console.log(only);
                                            const selectedVal = only.split(':')
                                            // const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (only == txtVal) {
                                                this.respOnlyVal += (+selectedVal[1])
                                                tmp2ValOnly = txtVal
                                            }
                                            // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                            // tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                        // if (prod.complements.multi.includes(txtVal)) {
                                        //     this.respMultipleVal += (+el.price)
                                        //     tmp2Val.push(txtVal)
                                        // }
                                    } else {
                                        // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });

                            }
                            tmpValues3 = tmpValues
                            // console.log(tmpValues);
                            tmpValues.forEach(val => {
                                tmpValues3.quantity = 1
                            });
                        }
                        this.optionsProd.push({
                            id: element.id,
                            title: element.title,
                            type: element.type,
                            values: tmpValues3,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: tmp2Val,
                            tmpValOnly: tmp2ValOnly,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false,
                            quantities: (element.quantities)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.tmpPriceCombination = (response.data.special_price) ? response.data.special_price : response.data.price
                this.priceNormal = response.data.price??0;
                if (response.data.stock > 0) {
                    this.stock = response.data.stock
                }

                // extra complements
                if (response.data.extra_complements.length > 0) {
                    this.extraComplements = JSON.parse(response.data.extra_complements[0].values)
                }

                // default data
                this.dataExtra = prod.extra
                this.quantity = prod.quantity
                this.respMultiple = prod.complements.multi
                this.respOnly = prod.complements.only

                setTimeout(() => {
                    this.loadProd = false
                }, 500);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event <= 1) {
                this.quantity = 1
            }
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.tmpFontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                    }
                })
            }
        },
        updateQuantitysComplements() {
            this.optionsProd.forEach(element => {
                if (element.quantities) {
                    if (element.tmpValOnly) {
                        let tmp = element.tmpValOnly.split(':')
                        element.values.forEach(item => {
                            if (item.name == tmp[0]) tmp[1] = item.price
                        });
                        tmp[1] = tmp[1]*this.quantity
                        element.tmpValOnly = tmp.join(':')
                    }
                    if (element.tmpVal.length > 0) {
                        element.tmpVal.forEach(val => {
                            const selectedId = document.getElementById(val)
                            const dataSelected = selectedId.getAttribute('data-details')
                            let tmp2 = dataSelected.split(':')
                            element.values.forEach(item => {
                                if (item.name == tmp2[0]) tmp2[1] = item.price
                            });
                            tmp2[1] = tmp2[1]*this.quantity
                            selectedId.setAttribute('data-details', tmp2.join(':'))
                        });
                    }
                }
            });
            this.changeRespOnly()
            this.changeRespMultiple()
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }

            this.updateQuantitysComplements()

            this.changeQuantity(this.quantity)
        },
        updateToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    priceNormal: (this.quantity * this.priceNormal) + this.respMultipleVal + this.respOnlyVal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    },
                    complementsTitles: this.getComplementsTitles()
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                tmpCart[this.tmpIndex] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.updateCartFromStore(localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$notify.success('Carrito actualizado con éxito.');
            }, 500);
        },

        /**
         * success
         */
        successOrder() {
            this.dialogPurchase = false
            this.openCart = false

            this.cart = {}
            this.cantProds = 0
            this.calculateTotal()
        },

        /**
         * open purchase
         */
        async openPurchase() {
            if (this.userId == '') {
                this.dialogPurchase = !this.dialogPurchase
                return
            }
            await axios.post(`/data-user/${this.userId}`, {store: this.slug})
            .then((response) => {
                // console.log(response);
                this.lastPurchase = response.data
                setTimeout(() => {
                    this.dialogPurchase = !this.dialogPurchase
                }, 300);
            })
            .catch((error) => {
                console.log(error);
                this.dialogPurchase = !this.dialogPurchase
            })

            this.getAttentions(this.listSchedules, false)
        },
        /**
         * Schedules
         */
        getAttentions(list, isOpen) {
            // this.$router.push('/checkout')
            var d = new Date();
            var weekday = new Array(7);
            weekday[0] = "Domingo";
            weekday[1] = "Lunes";
            weekday[2] = "Martes";
            weekday[3] = "Miercoles";
            weekday[4] = "Jueves";
            weekday[5] = "Viernes";
            weekday[6] = "Sábado";
            var today = weekday[d.getDay()];
            var hr = d.getHours()
            var min = d.getMinutes()

            list.forEach(element => {
                if (element.day == today) {
                    if (element.status) {
                        // console.log(element);
                        // open
                        const open = new Date()
                        const tmpOpen = element.open_hour.split(':')
                        open.setHours(+tmpOpen[0])
                        open.setMinutes(+tmpOpen[1])
                        open.setSeconds(+tmpOpen[2])
                        // closed
                        const closed = new Date()
                        const tmpClosed = element.closed_hour.split(':')
                        closed.setHours(+tmpClosed[0])
                        closed.setMinutes(+tmpClosed[1])
                        closed.setSeconds(+tmpClosed[2])
                        //
                        if (d.getTime() > open.getTime() && d.getTime() < closed.getTime()) {
                            console.log('abierto');
                            this.closedStore = false
                            if (isOpen) this.closedStoreDialog = false
                        } else {
                            console.log('cerrado');
                            this.closedStore = true
                            if (isOpen) this.closedStoreDialog = true
                        }
                    } else {
                        console.log('cerrado');
                        this.closedStore = true
                        if (isOpen) this.closedStoreDialog = true
                    }
                }
            });
        },

        /**
         * generate msg wsp
         */
        generateMsgWsp() {
            const cartValues = Object.values(this.cart);
            this.wspCart = `-- Producto --%0a`
            cartValues.forEach(element => {
                // console.log(element);
                this.wspCart += `   ${element.name}   %0a`
            });
            // console.log(this.wspCart);
        },

        /**
         * show notify
         */
        async showAds() {
            await axios.post(`/alerts/${this.slug}`, {})
            .then((response) => {
                if (JSON.stringify(response.data) != '{}') {
                    const tempData = JSON.parse(response.data.content)

                    if (tempData.state && !sessionStorage.getItem(`${this.slug}-notify`)) {
                        this.bannerNotify = tempData.banner
                        this.sizeNotify = tempData.size
                        this.dialogNotify = true
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },

        /**
         * time
         */
        async showCoupons() {
            this.listCoupons = []
            await axios.post(`/list-coupons/${this.slug}`, {})
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    const tmpEl = JSON.parse(element.content)
                    if ((+tmpEl.state)) {
                        this.listCoupons.push({
                            id: element.id,
                            name: element.title,
                            amount: tmpEl.amount,
                            minimum: tmpEl.minimum?tmpEl.minimum:'-',
                            state: (+tmpEl.state)?true:false
                        })
                    }
                    if (this.listCoupons.length > 0) {
                        this.showTimeDiv()
                    }
                });
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        showTimeDiv() {
            if (sessionStorage.getItem(`${this.slug}-timer`)) {
                let currentDate = new Date()
                this.currentTime = sessionStorage.getItem(`${this.slug}-timer`)
                let tmpTime = new Date(this.currentTime)

                // atento al tiempo
                let diffMin = tmpTime.getTime() - currentDate.getTime();
                let minutes = new Date(diffMin);
                setTimeout(() => {
                    sessionStorage.setItem(`${this.slug}-coupon`, false)
                    this.showListCoupons = false
                }, 1000 * 60 * ((diffMin <= 0)?0:(+minutes.getMinutes())) );

                // recargar la pagina
                if (diffMin <= 0) {
                    sessionStorage.setItem(`${this.slug}-coupon`, false)
                    this.showListCoupons = false
                }
            } else {
                let currentDate = new Date()
                currentDate.setMinutes(currentDate.getMinutes() + 20)
                sessionStorage.setItem(`${this.slug}-timer`, currentDate.toGMTString())
                this.currentTime = currentDate.toGMTString()
            }
            setTimeout(() => {
                if (this.listCoupons.length > 0) {
                    this.showTime = true
                }
            }, 300);
        },
        /**
         * apply coupon
         */
        async applyCoupon() {
            if (this.couponTxt != '' || this.couponTxt2 != '') {
                await axios.post('/apply-coupon', {coupon: ( (this.couponTxt!=='')?this.couponTxt:this.couponTxt2 ), slug: this.slug, total: this.total })
                .then((response) => {
                    // console.log(response)
                    this.nameCoupon = response.data.coupon

                    this.typeCoupon = response.data.type
                    if (this.typeCoupon == 'percentage') {
                        this.tmpValCoupon = response.data.amount
                        this.valCoupon = ((+this.total)*((+this.tmpValCoupon)/100))
                    } else {
                        this.valCoupon = response.data.amount
                    }

                    // this.$notify.success('Cupón válido.');
                    this.$fire({
                        title: 'Cupón aplicado exitosamente.',
                        text: '',
                        type: 'success',
                        confirmButtonText: 'Continuar',
                        confirmButtonColor: this.btnColor,
                        reverseButtons: true,
                        showCancelButton: false,
                        customClass: {
                            container: this.tmpFontFamily
                        }
                    })
                })
                .catch((error) => {
                    // console.log(error.response.data)
                    if (error.response.status == 403) {
                        if (error.response.data == 'used') {
                            // this.$notify.error('El cupón ya fue usado.');
                            this.$fire({
                                title: 'El cupón ya fue usado.',
                                text: '',
                                type: 'info',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: this.btnColor,
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.tmpFontFamily
                                }
                            })
                        }
                        if (error.response.data == 'no-exists') {
                            // this.$notify.error('Cupón inexistente.');
                            this.$fire({
                                title: 'Cupón inexistente.',
                                text: '',
                                type: 'info',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: this.btnColor,
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.tmpFontFamily
                                }
                            })
                        }
                        if (error.response.data == 'expired') {
                            // this.$notify.error('El cupón ya expiro.');
                            this.$fire({
                                title: 'El cupón ya expiro.',
                                text: '',
                                type: 'info',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: this.btnColor,
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.tmpFontFamily
                                }
                            })
                        }
                        if (error.response.data == 'not-enough') {
                            // this.$notify.error('El cupón solo es válido para una compra minima de '+this.minimumTxt+this.money);
                            this.$fire({
                                title: 'El cupón solo es válido para una compra minima de '+this.minimumTxt+this.money,
                                text: '',
                                type: 'info',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: this.btnColor,
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.tmpFontFamily
                                }
                            })
                        }
                    }
                })
            }
        },
        onCountdownEnd() {
            console.log('hello');
        },
        useCoupon() {
            this.couponTxt2 = this.listCoupons[0].name
            localStorage.setItem(`${this.slug}-coupon`, this.couponTxt)
            // sessionStorage.setItem(`${this.slug}-coupon`, true)
            // this.showListCoupons = true
            this.dialogNotify = false

            // popup coupon aplicado existosamente
            this.applyCoupon()
        },
        /**
         * lista de banners
         */
        async getMainBanner() {
            this.overlay = true
            this.dataBanners = []
            await axios.get(`/get-banners/${this.slug}`)
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    let content = JSON.parse(element.content)
                    content.id = element.id
                    this.dataBanners.push(content)
                });
                this.overlay = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * redes sociales
         */
        async getMainRrss() {
            this.overlay = true
            this.dataRrss = []
            await axios.get(`/get-rrss/${this.slug}`)
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    let content = JSON.parse(element.content)
                    this.dataRrss.push(content)
                });
                this.overlay = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
    },
    computed: {
        height () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 75
                case 'sm': return 100
                case 'md': return 120
                case 'lg': return 120
                case 'xl': return 120
            }
        },
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>

<style lang="scss">
.wrap-rrss {
    position: fixed;
    z-index: 9999;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    /* display: flex; */
    @media (max-width: 786px) {
        left: auto;
        right: 10px;
    }
}
.pb-btn {
    padding-bottom: 28px;
    @media (max-width: 1020px) {
        padding-bottom: 52px;
    }
}
.wrap-rrss .v-btn {
    opacity: .7;
}
.h-full {
    height: 100%;
}
</style>
